var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',{staticClass:"admin-layout"},[_c('admin-second-sidebar'),_c('a-layout',[_c('a-layout-content',{staticStyle:{"margin":"0 10px","padding":"20px","min-height":"280px"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }